import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import i18next from 'i18next';
import sprintf from 'i18next-sprintf-postprocessor';
export function initTranslation() {
  return _initTranslation.apply(this, arguments);
}
function _initTranslation() {
  _initTranslation = _asyncToGenerator(function* (locale = 'en-US', translation, options = {}) {
    const lng = locale.toLowerCase().substr(0, 2);
    i18next.use(sprintf).init(_extends({}, options, {
      debug: false,
      // Otherwise logging breaks in IE9
      resources: {
        [lng]: {
          translation
        }
      },
      lng: lng,
      fallbackLng: false,
      lowerCaseLng: true,
      postProcess: 'sprintf',
      compatibilityJSON: 'v3'
    }));
  });
  return _initTranslation.apply(this, arguments);
}
export function translate(key, args = {}) {
  return i18next.t(key, args);
}
//# sourceMappingURL=index.js.map